module.exports = __webpack_public_path__ + "img/esfj.62b6ac7e.png";